import React, { useState } from "react";
import { ChevronRight } from "./icons";

export const Faq = ({ data }) => {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="section faq">
      <div className="container">
        <h2 className="section-title">Questions fréquentes</h2>

        <div className="faq-list">
          {(data || []).map((item, i) => (
            <article className={`faq-item ${open === i ? "is-open" : ""}`} key={item.q}>
              <h3>
                <button
                  type="button"
                  onClick={() => setOpen(open === i ? -1 : i)}
                  aria-expanded={open === i}
                >
                  <ChevronRight size={16} />
                  {item.q}
                </button>
              </h3>
              {open === i && <p>{item.a}</p>}
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Faq;
